import axiosInstance from '@/utils/api.js'

var state = {
  hotspotService: []
}

var getters = {
  HOTSPOT_SERVICE: (state) => {
    return state.hotspotService
  }
}

var mutations = {
  SET_HOTSPOT_SERVICE: (state, payload) => {
    state.hotspotService = payload
  }
}

var actions = {
  GET_HOTSPOT_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/hotspot?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_HOTSPOT_SERVICE', result.data)
    }
  },
  CREATE_HOTSPOT_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/hotspot', payload)
  },
  SET_HOTSPOT_NETWORKS: (context, payload) => {
    return axiosInstance.put('/tariffing/hotspot_networks', payload)
  },
  UPDATE_HOTSPOT_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/hotspot', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/hotspotServices.js